<template>
	<div>
		<TopNav/>
		<div class="container">
			<div class="columns">
				<div id="main" class="column">
			<!-- End Profile header -->
			<section class="login">
			<div class="columns">
				<div class="column">
					<form class="is-maxed" v-on:keyup.enter="login">
						<h1>Please Sign In</h1>
						<label class="label">Username</label>
						<div class="field is-maxed">
							<div class="control has-icons-left is-expanded">
								<input class="input" type="text" placeholder="Username" v-model="username">
								<span class="icon is-small is-left">
								<i class="fa fa-user"></i>
								</span>
							</div>
						</div>
						<label class="label">Password</label>
						<div class="field is-maxed">
							<div class="control has-icons-left is-expanded">
								<input class="input" type="password" placeholder="Password" v-model="password">
								<span class="icon is-small is-left">
								<i class="fa fa-lock"></i>
								</span>
							</div>
						</div>
						<div class="field is-maxed">
							<div class="control">
								<a class="button is-small is-link" @click.prevent="login">Submit</a>
							</div>
						</div>
						<p>
							<router-link to="/forgot_password">Forgot Password?</router-link>
						</p>
					</form>
				</div>
			</div>
			</section>
		</div>
			</div>
		<div class="columns is-paddingless">
	<div class="column is-paddingless">
		<div class="footer">
			<div class="container">
				<div class="columns">
					<div class="column">
						<p>
							©Copyright 2020 Psychic Portal. All rights reserved.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
		</div>
	</div>
</template>

<script>
	import TopNav from "./TopNav.vue"

	export default {
		components: {
			TopNav
		},
		data() {
			return {
				username: "",
				password: ""
			}
		},
		methods: {
			login() {
				this.$root.$data.setters.authenticate(this.$root.$data.state, this.username, this.password).then(() => {
					const user = JSON.parse(localStorage.getItem("user"))
					if (user.manager !== null) {
						this.$router.push("/psychic")
					} else {
						this.$router.push("/dashboard")
					}
				}).catch((e) => {
					if (e.response && e.response === 401) {
						this.$notify({
							group: 'global',
							type: 'error',
							title: 'Login Not Successful',
							text: 'Your username or password was incorrect.',
						})
					} 
				})
			}
		},
		created() {
			document.title = "Psychic Portal"
		}
	}
</script>